const clickEventName: string =
  'ontouchstart' in document.documentElement ? 'touchstart' : 'click'

export default clickEventName
